import React from 'react';
import Checkbox from 'antd/lib/checkbox';
import classNames from 'classnames';

import { additionsClasses } from '../../../utils';

import style from './Checkbox.module.scss';

export const CheckboxInput = ({ additions = [ 'column' ], ...props }) => (
  <div className={ classNames(style.wrapper, additionsClasses(additions, style)) }>
    <Checkbox.Group className={ style.checkbox } { ...props } />
  </div>
);

